import { Tools, Content, Users, Data } from "drinkaware-tools-api-library";

export const toolsApi = new Tools(undefined, {
  $host: process.env.VUE_APP_TOOLS_API_BASE_LINK + "tools/v1",
  endpoint: process.env.VUE_APP_TOOLS_API_BASE_LINK + "tools/v1"
});

export const contentApi = new Content(undefined, {
  $host: process.env.VUE_APP_CONTENT_API_BASE_LINK + "/v1",
  endpoint: process.env.VUE_APP_CONTENT_API_BASE_LINK + "/v1"
});

export const usersApi = new Users(undefined, {
  endpoint: process.env.VUE_APP_TOOLS_API_BASE_LINK + "users/v1",
  $host: process.env.VUE_APP_TOOLS_API_BASE_LINK + "users/v1"
});

export const dataApi = new Data(undefined, {
  endpoint: process.env.VUE_APP_TOOLS_API_BASE_LINK + "data/v1",
  $host: process.env.VUE_APP_TOOLS_API_BASE_LINK + "data/v1"
});
